import { RedoOutlined, TagsOutlined } from '@ant-design/icons'
import { Card, Col, Row } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import FormEditWordType from 'src/common/DictionaryModal/components/Dictionary/components/FormEditWordType/FormEditWordType'
import { onResetDefinition } from 'src/redux/definition/definition.actions'
import {
	ButtonCommon,
	DictionaryModal,
	ListPageIntro,
	ListPageShell,
	ListPageTotal,
	PaginationCommon,
	PopoverCommon,
	TableCommon,
} from '../../common'
import { useAppDispatch, useAppSelector } from '../../hooks'
import {
	onGetAllDictWordTypes,
	onSelectWordType,
} from '../../redux/dict/dict.action'
import {
	selectCurrentPageDictWordTypes,
	selectDictWordTypes,
	selectTotalDictWordTypes,
} from '../../redux/dict/dict.selector'
import { DEFAULT_PAGE_SIZE } from '../../utils/constant'

import { DictWordTypeAction } from './components/DictWordTypeAction'

import './WordTypes.scss'

export const WordTypes = () => {
	const [modalVisible, setModalVisible] = useState(false)
	const dispatch = useAppDispatch()
	const data = useAppSelector(selectDictWordTypes)
	const total = useAppSelector(selectTotalDictWordTypes)
	const currentPage = useAppSelector(selectCurrentPageDictWordTypes)
	const [isLoading, setIsLoading] = useState()

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			width: 72,
		},
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
		},
		{
			title: 'Language code',
			dataIndex: 'isTypeLanguage',
			key: 'isTypeLanguage',
		},
		{
			title: 'Action',
			dataIndex: 'id',
			key: 'action',
			width: 120,
			render: (_, record) => {
				return <DictWordTypeAction data={record} onEdit={onEditClick} />
			},
		},
	]
	const onGetDataCb = useCallback(() => {
		setIsLoading(false)
	}, [])

	const onChangePage = page => {
		setIsLoading(true)
		dispatch(
			onGetAllDictWordTypes(
				{
					pageNum: page - 1,
					pageSize: DEFAULT_PAGE_SIZE,
				},
				onGetDataCb
			)
		)
	}

	useEffect(() => {
		setIsLoading(true)
		dispatch(
			onGetAllDictWordTypes(
				{
					pageNum: 0,
					pageSize: DEFAULT_PAGE_SIZE,
				},
				onGetDataCb
			)
		)
	}, [dispatch, onGetDataCb])

	const handleReload = () => {
		setIsLoading(true)
		dispatch(
			onGetAllDictWordTypes(
				{
					pageNum: 0,
					pageSize: DEFAULT_PAGE_SIZE,
				},
				onGetDataCb
			)
		)
	}

	const getRowKey = record => {
		return record.id
	}
	const handleModalCancel = () => {
		setModalVisible(false)
	}

	const onEditClick = record => {
		dispatch(onSelectWordType(record))
	}
	const onAddClick = () => {
		dispatch(onResetDefinition(''))
	}

	return (
		<ListPageShell>
			<div className="list-page-bar">
				<ListPageIntro
					icon={TagsOutlined}
					title="Word types"
					subtitle="Dictionary word type labels used across entries."
				/>
				<ListPageTotal total={total} />
			</div>
			<Card className="list-page-toolbar-card word-types__toolbar" size="small" bordered>
				<Row align="middle" justify="space-between" gutter={[16, 16]}>
					<Col>
						<ButtonCommon
							onClick={handleReload}
							icon={<RedoOutlined />}
							type="primary"
						>
							Reload
						</ButtonCommon>
					</Col>
					<Col>
						<PopoverCommon content={<FormEditWordType />} trigger="click">
							<ButtonCommon
								size="small"
								ghost
								type="primary"
								onClick={onAddClick}
							>
								+ Add type word
							</ButtonCommon>
						</PopoverCommon>
					</Col>
				</Row>
			</Card>

			<TableCommon
				className="table-common--fluid"
				columns={columns}
				dataSource={data}
				pagination={false}
				rowKey={getRowKey}
				loading={isLoading}
			/>
			<PaginationCommon
				align="center"
				total={total}
				currentPage={currentPage}
				onChangePage={onChangePage}
			/>
			<DictionaryModal
				visible={modalVisible}
				onClose={handleModalCancel}
			/>
		</ListPageShell>
	)
}
